import { useLocation } from "@remix-run/react";
import { useEffect } from "react";

import { useNavigationHistoryStore } from "~/lib/stores/navigationHistory";
import { useCurrentUserStore } from "~/modules/common/store/useCurrentUserStore";

export function useNavigationTracker() {
  const location = useLocation();
  const currentUser = useCurrentUserStore((state) => state.currentUser);

  const clearHistory = useNavigationHistoryStore((state) => state.clearHistory);

  const isAuthRoute = location.pathname.startsWith("/auth");
  const isRootRoute = location.pathname === "/";

  // Scroll to top on route change (instant, not smooth — smooth gets interrupted by React renders)
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  // Sólo los clientLoaders de rutas PROTEGIDAS guardan un retorno. Antes este tracker registraba
  // cualquier landing pública y dejaba destinos viejos en sessionStorage. Volver voluntariamente
  // a la home cancela cualquier retorno protegido pendiente.
  useEffect(() => {
    if (!currentUser && !isAuthRoute && isRootRoute) clearHistory();
  }, [clearHistory, currentUser, isAuthRoute, isRootRoute]);
}
